import { IBlog } from "../../types/CommonTypes";
import { formatedDate } from "../../commons/constants/helpers";
import "./landing.css";

const dateLabel = (blog: IBlog) => {
	const raw = blog.createdAt || blog.date;
	if (!raw) return "";
	// formatedDate entiende el formato legado "DD-MM-YYYY" y devuelve el texto
	// original si no logra interpretarlo; new Date() lo leía como MM-DD-YYYY.
	return formatedDate(raw);
};

// Las publicaciones son piezas gráficas, no artículos: no llevan enlace.
const NewsCard = ({ blog }: { blog: IBlog }) => (
	<article className="ld-news-card">
		<img src={blog.picture?.url} alt={blog.title || ""} loading="lazy" />
		<div className="ld-news-body">
			{dateLabel(blog) && (
				<span className="ld-news-date">{dateLabel(blog)}</span>
			)}
			<h3 className="ld-news-title">{blog.title}</h3>
		</div>
	</article>
);

export default NewsCard;
